export const trackerArticleId = 27;
